// src/App.js
import { useEffect , useState} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import DonationManagement from "./pages/DonationManagment";
import DonorManagement from "./pages/DonorManagement";
import ImportDataPage from "./pages/ImportData";
import Report from "./pages/Report";
import UserList from "./pages/UserList";
import ForgotPasswordForm from "./components/ForgotPassword/ForgotPasswordForm";
import ResetPasswordForm from "./components/ForgotPassword/ResetPasswordForm";
import ErrorBoundary from "./components/ErrorBoundary";
import PrivateRoute from "./components/PrivateRoute";
import { setupClickLogger } from "./utils/globalClickTracker";
import { setupGlobalErrorTracking } from "./utils/GlobalLogger";
import ResetPrasadPage from "./pages/ResetPrasadPage";
import DropdownManager from "./pages/ManageOptions";
import "./Styles/D3.css"


const App = () => {
  const { user } = useSelector((state) => state.auth);
  const { isAuthenticated } = useSelector((state) => state.auth);
  useEffect(() => {
    setupClickLogger(user);
    setupGlobalErrorTracking();
  }, [user]);

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ? <Navigate to="/dashboard" /> : <AuthPage />
            }
          />
          <Route
            path="/login"
            element={<AuthPage />}
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/donors"
            element={
              <PrivateRoute>
                <DonorManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/donations"
            element={
              <PrivateRoute>
                <DonationManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/import-data-page"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin1", "admin2"]}>
                <ImportDataPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Report />
              </PrivateRoute>
            }
          />
          <Route
            path="/reset-prasad"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin1", "admin2"]}>
                <ResetPrasadPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/user-list"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin1", "admin2"]}>
                <UserList />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-options"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin1", "admin2"]}>
                <DropdownManager />
              </PrivateRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route
            path="/reset-password/:token"
            element={<ResetPasswordForm />}
          />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
